/**
 * Shop-by-brand navigation, built from the same Configuration table as the
 * brand pages (Extensions > Clemtex Brand Pages):
 *
 *   - Desktop: the "All Items" dropdown shows featured brands as logo tiles,
 *     then every brand A-Z. The menu entries themselves come from the site's
 *     Navigation setting (All Items > Shop by Brand); this module only fills
 *     the dropdown panel, so the theme keeps handling hover/open/close.
 *   - /brands: the same featured row and A-Z list as a page, which is what the
 *     mobile menu's "Shop by Brand" entry opens.
 *
 * The header is rendered by the theme (Header.Menu is not a public module in
 * Safe Mode), so the panel is placed into the rendered markup and re-placed
 * whenever the header re-renders (login, cart, etc.).
 */
define('Clemtex.Brands.Menu', [
    'Clemtex.Brands.Utils',
    'Backbone',
    'jQuery',
    'underscore',
    'clemtex_brands_menu.tpl',
    'clemtex_brands_index.tpl'
], function (Utils, Backbone, jQuery, _, menuTpl, indexTpl) {
    'use strict';

    var PANEL_CLASS = 'clemtex-brands-menu';
    var installed = false;

    // The anchor whose dropdown we fill: the configured All Items entry.
    function allItemsItem() {
        return jQuery('.header-menu-level1-anchor.header-menu-shop-anchor').first().closest('li');
    }

    function fillDropdown(menu, settings) {
        var $li = allItemsItem();
        if (!$li.length || $li.find('.' + PANEL_CLASS).length) { return; }
        var $container = $li.children('.header-menu-level-container');
        if (!$container.length) {
            // no configured sub-entries: create the theme's own container so its
            // open/close styling applies
            $container = jQuery('<ul class="header-menu-level-container"></ul>').appendTo($li);
            if (!$li.attr('data-toggle')) { $li.attr('data-toggle', 'categories-menu'); }
        }
        $container.addClass('clemtex-brands-menu-container').html(menuTpl({
            featured: menu.featured,
            hasFeatured: menu.featured.length > 0,
            columns: _.map(Utils.columns(menu.all, settings.menuColumns), function (col) { return { brands: col }; }),
            allItemsUrl: '/search',
            allBrandsUrl: '/brands'
        }));
    }

    var BrandsIndexView = Backbone.View.extend({
        template: indexTpl,
        title: 'Shop by Brand',
        page_header: 'Shop by Brand',
        attributes: { id: 'clemtex-brands-index', 'class': 'clemtex-brands-index' },

        initialize: function (options) {
            this.menu = (options && options.menu) || { featured: [], all: [] };
            this.siteName = (options && options.siteName) || '';
        },
        getTitle: function () { return 'Shop by Brand' + (this.siteName ? ' | ' + this.siteName : ''); },
        getMetaDescription: function () {
            return 'Shop blasting, coating and inspection equipment by manufacturer at ' + (this.siteName || 'Clemtex') +
                ': ' + _.pluck(this.menu.featured, 'label').join(', ') + ' and more.';
        },
        getBreadcrumbPages: function () { return [{ text: 'Shop by Brand', href: '/brands' }]; },
        getContext: function () {
            return {
                featured: this.menu.featured,
                hasFeatured: this.menu.featured.length > 0,
                brands: this.menu.all
            };
        },
        render: function () {
            this.$el.html(this.template(this.getContext()));
            this.trigger('afterViewRender', this);
            return this;
        }
    });

    return {
        BrandsIndexView: BrandsIndexView,

        install: function install(menu, settings, pageTypeComponent, layout) {
            if (installed) { return; }
            installed = true;

            if (pageTypeComponent && menu.all.length) {
                pageTypeComponent.registerPageType({
                    name: 'clemtex-brands-index',
                    routes: ['brands', 'brands?*options'],
                    view: BrandsIndexView,
                    defaultTemplate: { name: 'clemtex_brands_index.tpl', displayName: 'Shop by Brand' },
                    options: { menu: menu, siteName: settings.siteName }
                });
            }

            if (!settings.menuInDropdown || !menu.all.length) { return; }

            var schedule = _.debounce(function () {
                try { fillDropdown(menu, settings); } catch (e) {
                    if (window.console) { window.console.error('ClemtexBrands menu failed', e); }
                }
            }, 50);
            schedule();
            if (layout && layout.on) { layout.on('afterShowContent', schedule); }
            // the header re-renders on its own (profile, cart): watch for it
            if (window.MutationObserver) {
                // cheap check: runs on every DOM change (infinite scroll etc.)
                new window.MutationObserver(function () {
                    var a = document.querySelector('.header-menu-level1-anchor.header-menu-shop-anchor');
                    var li = a && a.parentNode;
                    if (li && !li.querySelector('.' + PANEL_CLASS)) { schedule(); }
                }).observe(document.body, { childList: true, subtree: true });
            }
        }
    };
});
